export default {"src":"/_next/static/media/CSCO.51198808.svg","height":18,"width":18};